import React from 'react';
import { Link } from '@tanstack/react-router';
import PageHeader from '../../../components/layout/PageHeader';
import DashboardOverview from '../components/DashboardOverview';
import { PlusCircle } from 'lucide-react';

export const DashboardPage: React.FC = () => {
  return (
    <>
      <PageHeader
        title="Dashboard"
        description="Overview of your historical document management system"
        actions={
          <Link
            to="/documents/add"
            className="inline-flex items-center justify-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
          >
            <PlusCircle className="h-4 w-4" />
            <span>Add Document</span>
          </Link>
        }
      />
      <DashboardOverview />
    </>
  );
};

export default DashboardPage;
